import React from 'react';
import { Mail, Loader2, Trash2, UserPlus } from 'lucide-react';
import { EmptyState } from '../../components/ui/PageLayout';

export default function MembersInvitesTab({
  invites,
  deletingInviteId,
  handleDeleteInvite,
  setAddMemberOpen,
}: any) {
  return (
    <div role="tabpanel" id="members-tabpanel-invites" aria-labelledby="members-tab-invites">
      <section>
        {invites.length === 0 ? (
          <EmptyState
            icon={<Mail className="w-12 h-12 text-slate-500" />}
            title="No pending invites"
            description="Invites you send will appear here until they are accepted or expire."
            action={
              <button
                type="button"
                onClick={() => setAddMemberOpen(true)}
                className="empty-state-cta-mdl inline-flex items-center gap-2"
                aria-label="Invite member"
              >
                <UserPlus className="w-5 h-5" />
                Invite
              </button>
            }
          />
        ) : (
          <div className="cards-grid-mdl-dense">
            {invites.map((inv) => (
              <div key={inv.id} className="card-mdl p-4 flex items-center gap-3">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-dark-elevated flex items-center justify-center">
                  <Mail className="w-5 h-5 text-slate-400" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-slate-100 truncate">{inv.email}</p>
                  <p className="text-sm text-slate-400">
                    Expires {inv.expiresAt ? new Date(inv.expiresAt).toLocaleDateString() : '—'}
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => handleDeleteInvite(inv.id)}
                  disabled={deletingInviteId === inv.id}
                  className="flex-shrink-0 btn-icon-mdl w-9 h-9 rounded-lg disabled:opacity-50"
                  aria-label="Cancel invite"
                  title="Cancel invite"
                >
                  {deletingInviteId === inv.id ? (
                    <Loader2 className="w-5 h-5 animate-spin" />
                  ) : (
                    <Trash2 className="w-5 h-5" />
                  )}
                </button>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
